import { render, staticRenderFns } from "./WeeklyHistory.vue?vue&type=template&id=3199776f&"
import script from "./WeeklyHistory.vue?vue&type=script&lang=js&"
export * from "./WeeklyHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports